import { ref } from "vue";
import api from "@/api/client";

// Module-level singleton so every consumer sees the same reactive value
// and we never re-fetch /api/info just for the title. Empty until /api/info
// resolves the active event's name — consumers show a skeleton while empty so
// the login splash never flashes a hard-coded wrong event name on load.
const eventTitle = ref("");
let loaded = false;

async function loadEventTitle() {
  if (loaded) return;
  loaded = true;
  try {
    const r = await api.get("/info");
    const t: string | undefined = r.data?.blocks?.event_title?.body_html;
    if (t) {
      eventTitle.value = t;
      document.title = t;
    }
  } catch {
    /* keep default — index.html title and the ref's initial value
       both stay as the build-time fallback */
  }
}

export function useEventTitle() {
  return { eventTitle, loadEventTitle };
}
